import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

/**
 * Circular Add Icon component using the provided SVG path
 * 
 * @param {Object} props - Component props from SvgIcon
 * @returns {JSX.Element} Circular add icon SVG component
 */
const CircularAddIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 32 32" {...props}>
      <path 
        id="plus-circle-solid" 
        d="M34,18A16,16,0,1,1,18,2,16,16,0,0,1,34,18Zm-8.41-1.5H19.5V10.41a1.5,1.5,0,0,0-3,0V16.5H10.41a1.5,1.5,0,0,0,0,3H16.5v6.09a1.5,1.5,0,1,0,3,0V19.5h6.09a1.5,1.5,0,1,0,0-3Z" 
        transform="translate(-2 -2)" 
        fill={props.fill || "#475969"}
      />
    </SvgIcon>
  );
};

export default CircularAddIcon;